/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebUserLikedModel
 */
export interface FrontWebUserLikedModel {
    /**
     * id
     * @type {string}
     * @memberof FrontWebUserLikedModel
     */
    id: string;
    /**
     * slug
     * @type {string}
     * @memberof FrontWebUserLikedModel
     */
    slug: string;
    /**
     * poslech
     * @type {number}
     * @memberof FrontWebUserLikedModel
     */
    listenedTime: number;
}

/**
 * Check if a given object implements the FrontWebUserLikedModel interface.
 */
export function instanceOfFrontWebUserLikedModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "listenedTime" in value;

    return isInstance;
}

export function FrontWebUserLikedModelFromJSON(json: any): FrontWebUserLikedModel {
    return FrontWebUserLikedModelFromJSONTyped(json, false);
}

export function FrontWebUserLikedModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebUserLikedModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'slug': json['slug'],
        'listenedTime': json['listenedTime'],
    };
}

export function FrontWebUserLikedModelToJSON(value?: FrontWebUserLikedModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'slug': value.slug,
        'listenedTime': value.listenedTime,
    };
}

